import CheckboxWithImage from "@/components/ui/checkbox-with-image.tsx";
import { useTranslations } from "@/features/translations/components/translations.tsx";
import type { FilterProps } from "./index.tsx";

export default function RadioImages({ choices, configCode, onClick }: FilterProps) {
    const t = useTranslations();

    return (
        <div className="filters--radio-images filters--horizontal">
            {choices.map((choice) => {
                return (
                    <CheckboxWithImage
                        key={choice.value}
                        image={choice.image}
                        label={t(choice.label)}
                        description={choice.description}
                        isPossible={choice.isPossible}
                        tooltip={choice.tooltip}
                        isChecked={configCode === choice.configCode}
                        onClick={() => onClick(choice.configCode || null, choice.isPossible)}
                    />
                );
            })}
        </div>
    );
}
